module.exports = __webpack_public_path__ + "iPad_air.svg?c8141344a591e4fa82c91375892ec640";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/iPad_air.svg
// module id = 222
// module chunks = 0